var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v("Ventes globales")]),_c('order-item-stats-graph',{attrs:{"default-display-option":2,"graph-end":_vm.getGraphEnd,"graph-start":_vm.getGraphStart,"groupBy":"month"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }